<template>
	<div id="mian">
	<div class="seel" @change="chartmap">
		<input type="radio"  name="selected"   id='0' value="0"  v-model="search_type"> Events notification<br>
	<input type="radio" name="selected"  id='1' value="1" v-model="search_type"> Popularization of prevention and treatment<br>
	<input type="radio"  name="selected"  id='2' value="2" v-model="search_type"> Government response<br>
    <input type="radio"  name="selected"   id='3' value="3"  v-model="search_type"> Personal response<br>
	<input type="radio" name="selected"  id='4' value="4" v-model="search_type"> Opinion and sentiments<br>
	<input type="radio"  name="selected"  id='5' value="5" v-model="search_type"> Seeking help<br>
	<input type="radio"  name="selected" id='6' value="6" v-model="search_type"> Making donations<br>
</div>
  <div id="wq" class="hhh">3233232</div>

  </div>
</template>

<script>
	import echarts from 'echarts'
	
	import '../../node_modules/echarts/map/js/china.js'
	
	import data from "../assets/firstdata.json"
	import english from "../assets/english.json"
export default {
  name: '',
 
  data(){
	return{
		cchart:'',
	
		search_type:'0',
		
	}
  },
  methods:{
	chartmap(){
		
		this.kkk=this.search_type;
		this.cchart = echarts.init(document.getElementById('wq'));
	this.cchart.setOption({
		tooltip:{
			trigger: 'item',
		formatter: function (val) {
		if(val.data == null) return ;
		return val.data.name + ': ' + val.data.value
		}
		},
							
							title: {
							
							left:'center',
						
							},
							visualMap: {
							max: 9000,
							min:0,
							calculable: true,
							inRange: {
							color: ['#FFFFFF','#ca6565' ,'#cb3f3f','#c91d1d'],
							
							}
							},
							series: [{
								label:{
									
									normal:{
										show:true,
										fontSize:9
									}
								},
							type: 'map',
							mapType: 'china',
							roam: true,
							silent:false,
							zoom:1.2,
							// center: [150, 36],
							data:data[this.search_type],
							nameMap:english,
							}
							],
							
						
							
							
	});
	window.onresize=()=>{
			this.cchart.resize();
		};
	
 } 
 },
 mounted(){

	this.$nextTick(function() {
        this.chartmap()

    })
 }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hhh{
	width: 70%;
	height: 100%;
	left: 0;
	vertical-align: top;
}
.seel{
	background-color: rgba(255,255,255,0.7);
	z-index: 1000;
	text-align: left;
	float: right;
	bottom: 0;
	display: block;
	position: relative;
	border-style: dashed;
	padding: 10px;
	margin-right: 15px;
	border-radius: inherit;

}
#mian{
	background-color: #e7e7e7;
	width: 100%;height: 400px; 
	padding: 15px;
	position: relative;
}
</style>
